import SaveFooterLayout from '../../layouts/SaveFooterLayout';
import { UserAlias } from '../../store/user/types';
import ChangePasswordForm, { ChangePasswordFormFields } from '../ChangePasswordForm/ChangePasswordForm';
import MainEmailForm from '../MainEmailForm/MainEmailForm';

interface Props {
  userId: number;
  userAliasById: {
    [key: number]: UserAlias;
  };
  passwordSet: boolean;
  validationErrors: { [k: string]: string };
  onUpdateMainAlias: (userId: number) => void;
  onChangePassword: (form: ChangePasswordFormFields) => void;
  clearValidationErrorsAction: () => void;
  onCancel?: () => void;
}

const SecurityProfileForm: React.FC<Props> = ({
  userId,
  userAliasById,
  passwordSet,
  validationErrors,
  onUpdateMainAlias,
  onChangePassword,
  clearValidationErrorsAction,
  onCancel,
}) => {
  const forms = (
    <>
      <div className="flex justify-center mt-10 gap-x-32 mobileCtrlPassWordFormWrapper">
        <div className="flex flex-col mobileCtrlPassWordFormEmail">
          <MainEmailForm user_alias_by_id={userAliasById} main_user_id={userId} save_handler={onUpdateMainAlias} />
        </div>

        <div className="flex flex-col mobileCtrlPassWordFormChangePassword">
          <ChangePasswordForm
            save_handler={onChangePassword}
            password_set={passwordSet}
            validation_error={validationErrors}
            clearValidationErrorsAction={clearValidationErrorsAction}
          />
        </div>
      </div>
      {/*          <StyledMessage severity="error" handleClose={() => {}} hideClose={true} className="mt-12 mx-auto w-full mobileCtrlDeleteAccountMessage">
      <div className="flex items-center gap-x-40">
          <div className="flex flex-col">
          <p className="text-xl font-medium mb-1">{t('Delete account')}</p>
          <p className="text">{t('Please be aware that this action cannot be undone')}</p>
          </div>
          <div className="">
          <CancelButton variant="solid" onClick={undefined} className="w-24 place-self-center">
              <span className="px-14">{t('Delete')}</span>
          </CancelButton>
          </div>
      </div>
      </StyledMessage>*/}
    </>
  );

  return <SaveFooterLayout onCancel={onCancel}>{forms}</SaveFooterLayout>;
};

export default SecurityProfileForm;
